import { useWallet as useSolanaWallet } from "@solana/wallet-adapter-react";
import { useMemo } from "react";

import {
  AptosSVG,
  CoinbaseWalletSVG,
  KeplrSVG,
  MartianWalletSVG,
  MetamaskSVG,
  PetraWalletSVG,
  RiseWalletSVG,
  WalletConnectSVG,
  XDEFISVG,
} from "../../assets";
import { WalletInfo } from "../../interfaces";

// There is no Solana here, because its wallet adapters contain icons and names already.
type network = "evm" | "cosmos" | "aptos";

const staticSupportedWalletsMap: Record<network, Record<string, WalletInfo>> = {
  evm: {
    metamask: {
      id: "metamask",
      name: "Metamask",
      logo: <MetamaskSVG />,
    },
    coinbase: {
      id: "coinbase",
      name: "Coinbase",
      logo: <CoinbaseWalletSVG />,
    },
    walletConnect: {
      id: "walletConnect",
      name: "Wallet Connect",
      logo: <WalletConnectSVG />,
    },
    xdefi: {
      id: "xdefi",
      name: "XDEFI Wallet",
      logo: <XDEFISVG />,
    },
  },
  cosmos: {
    keplr: {
      id: "keplr",
      name: "Keplr",
      logo: <KeplrSVG />,
    },
    keplrMobile: {
      id: "keplrMobile",
      name: "Keplr Mobile",
      logo: <KeplrSVG />,
    },
  },
  aptos: {
    Pontem: {
      id: "Pontem",
      name: "Pontem",
      logo: <AptosSVG />,
    },
    Martian: {
      id: "Martian",
      name: "Martian",
      logo: <MartianWalletSVG />,
    },
    Petra: {
      id: "Petra",
      name: "Petra",
      logo: <PetraWalletSVG />,
    },
    "Rise Wallet": {
      id: "Rise Wallet",
      name: "Rise Wallet",
      logo: <RiseWalletSVG />,
    },
  },
};

export const useSupportedWalletsMap = () => {
  const { wallets } = useSolanaWallet();

  const solanaWalletsMap = useMemo(() => {
    return wallets.reduce(
      (acc, wallet) => ({
        ...acc,
        [wallet.adapter.name]: {
          id: wallet.adapter.name,
          name: wallet.adapter.name,
          logo: (
            <img
              src={wallet.adapter.icon}
              alt={wallet.adapter.name}
              width={24}
              height={24}
            />
          ),
        },
      }),
      {} as Record<string, WalletInfo>,
    );
  }, [wallets]);

  return {
    ...staticSupportedWalletsMap,
    solana: solanaWalletsMap,
  };
};

export type AptosWalletId = "Pontem" | "Martian" | "Petra" | "Rise Wallet";
